import request from '@/router/axios'
import env from '@/config/env'


/**
 * 新增站点管理
 * @param {对象参数} data
 * @returns
 */
export const saveAddressBelong = (data) => {
    return request({
        url: env.ferryUrl + '/areaManage/save',
        method: 'POST',
        data: data
    })
}


/**
 * 删除地级归属
 * @param {删除id} id
 * @returns
 */
export const deleteRegion = (id) => {
    return request({
        url: env.ferryUrl + `/areaManage/delete/${id}`,
        method: 'DELETE'
    })
}

/**
 * 获取低级归属区域数据
 * @param data
 */
export const getRegionTree = () => {
    return request({
        url: env.ferryUrl + '/areaManage/tree',
        //url: 'http://192.168.1.102:38000/areaManage/tree',
        method: 'post',
    })
}


/**
 * 编辑地级归属区域数据
 * @param data
 */
export const updateRegion = (data) => {
    return request({
        url: env.ferryUrl + '/areaManage/update',
        method: 'PUT',
        data: data
    })
}


